export default "__VITE_ASSET__BqbWCOed__"